// services/Recruit/services/offerLetterService.js
import axios from 'axios';
import { constant } from 'common/constant';
import { getApi, postApi, putApi, deleteApi } from 'common/services/api';

class OfferLetterService {
    // Offer Letters
    async createOfferLetter(data) {
        const response = await postApi('api/recruitment/offer-letters', data);
        return response.data;
    }

    async getOfferLetters(params = {}) {
        const queryString = new URLSearchParams(params).toString();
        const path = queryString ? `api/recruitment/offer-letters?${queryString}` : 'api/recruitment/offer-letters';
        const response = await getApi(path);
        return response.data;
    }

    async getOfferLetter(id) {
        const response = await getApi(`api/recruitment/offer-letters/${id}`);
        return response.data;
    }

    async updateOfferLetter(id, data) {
        const response = await putApi(`api/recruitment/offer-letters/${id}`, data);
        return response.data;
    }

    async updateOfferExpiryDate(id, offerExpiryDate, joiningDate) {
        const response = await putApi(`api/recruitment/offer-letters/${id}/expiry-date`, { offerExpiryDate, joiningDate });
        return response.data;
    }

    async releaseOfferLetter(id) {
        const response = await postApi(`api/recruitment/offer-letters/${id}/release`, {});
        return response.data;
    }

    async revokeOfferLetter(id, reason) {
        const response = await postApi(`api/recruitment/offer-letters/${id}/revoke`, { reason });
        return response.data;
    }

    async deleteOfferLetter(id) {
        const response = await deleteApi(`api/recruitment/offer-letters/${id}`, '');
        return response.data;
    }

    async deleteManyOfferLetters(ids) {
        const response = await postApi('api/recruitment/offer-letters/deleteMany', ids);
        return response.data;
    }

    async downloadOfferPDF(id) {
        const token = localStorage.getItem("token") || sessionStorage.getItem("token");

        const response = await axios({
            url: `${constant.baseUrl}api/recruitment/offer-letters/${id}/download`,
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
            responseType: 'arraybuffer',
        });

        return new Blob([response.data], { type: 'application/pdf' });
    }

    // Templates
    async createTemplate(data) {
        const response = await postApi('api/recruitment/offer-letter-templates', data);
        return response.data;
    }

    async getTemplates(params = {}) {
        const queryString = new URLSearchParams(params).toString();
        const path = queryString ? `api/recruitment/offer-letter-templates?${queryString}` : 'api/recruitment/offer-letter-templates';
        const response = await getApi(path);
        return response.data;
    }

    async getTemplate(id) {
        const response = await getApi(`api/recruitment/offer-letter-templates/${id}`);
        return response.data;
    }

    async updateTemplate(id, data) {
        const response = await putApi(`api/recruitment/offer-letter-templates/${id}`, data);
        return response.data;
    }

    async deleteTemplate(id) {
        const response = await deleteApi(`api/recruitment/offer-letter-templates/${id}`, '');
        return response.data;
    }

    async deleteManyTemplates(ids) {
        const response = await postApi('api/recruitment/offer-letter-templates/deleteMany', ids);
        return response.data;
    }

    async duplicateTemplate(id) {
        const response = await postApi(`api/recruitment/offer-letter-templates/${id}/duplicate`, {});
        return response.data;
    }

    async previewTemplate(id) {
        const response = await getApi(`api/recruitment/offer-letter-templates/${id}/preview`);
        return response.data;
    }

    async getTemplateAnalytics() {
        const response = await getApi('api/recruitment/offer-letter-templates-analytics');
        return response.data;
    }
}

// Fix: Assign to variable before exporting
const offerLetterService = new OfferLetterService();
export default offerLetterService;